import { render, staticRenderFns } from "./General.vue?vue&type=template&id=54106f5a&scoped=true"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"
import style0 from "./General.vue?vue&type=style&index=0&id=54106f5a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54106f5a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/General.vue
// module id = 611
// module chunks = 31